export enum PARTNER_KINDS {
  ASSESSMENT = 'assessment',
  BACKGROUND_CHECK = 'background_check',
  REFERENCE_CHECK = 'reference_check',
}

export type Partner = {
  id: string;
  kind: PARTNER_KINDS;
  authenticationMethod: 'token';
  promoted: boolean;
  codename: string;
  name: string;
  description: string | null;
  logoSvg: string | null;
  urls: {
    helpArticle: string | null;
  };
  adminId: number;
  companyId: number;
};
